module.exports = __webpack_public_path__ + "img/cat.63003ac4.jpg";